import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';
import About from './componenets/About';
import ContactMe from './componenets/ContactMe';
import Home from './componenets/Home';
import HomeNav from './componenets/HomeNav';
import MyWorks from './componenets/MyWorks';
import Skills from './componenets/Skills';
import Helmet from 'react-helmet'

function App() {
  const [pathName, setPathName] = useState(window.location.pathname)


  return (
    <main>
      <Helmet>

        <title>Shakthi's Portfolio</title>
        <meta name="description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer. 
        A student of SASTRA Deemed to be University." />
        <meta name="google-site-verification" content="Iw5fniSyefKh1MwUJCfIgMUX_5Avtj3MszSUm0CUBbI" />
        <meta itemprop="name" content="Shakthi's Portfolio" />
        <meta itemprop="description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer. 
        A student of SASTRA Deemed to be University." />
        <meta itemprop="image" content="https://shakthi-ganesh-r-portfolio.web.app/static/media/CropImage.0880ee6a.png" />

        <meta property="og:url" content="https://shakthi-ganesh-r-portfolio.web.app" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Shakthi's Portfolio" />
        <meta property="og:description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer.
        A student of SASTRA Deemed to be University." />
        <meta property="og:image" content="https://shakthi-ganesh-r-portfolio.web.app/static/media/CropImage.0880ee6a.png" />


        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Shakthi's Portfolio" />
        <meta name="twitter:description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer.
        A student of SASTRA Deemed to be University." />
        <meta name="twitter:image" content="https://shakthi-ganesh-r-portfolio.web.app/static/media/CropImage.0880ee6a.png" />

      </Helmet>
      <div className="App">
        <BrowserRouter>
          <h1 style={{ display: "none" }}>Shakthi Ganesh R's portfolio</h1>
          <HomeNav className='home_homenav' pathName={pathName} />
          <Switch>
            <Route path='/aboutme' exact>
              <About setPathName={setPathName} />
            </Route>
            <Route path='/skills' exact>
              <Skills setPathName={setPathName} />
            </Route>
            <Route path='/myworks' exact>
              <MyWorks setPathName={setPathName} />
            </Route>
            <Route path='/contactme' exact>
              <ContactMe setPathName={setPathName} />
            </Route>
            <Route path='/'  >
              <Home setPathName={setPathName} />
            </Route>
          </Switch>
        </BrowserRouter>


      </div>
    </main>
  );
}

export default App;
